import { render, staticRenderFns } from "./createQuestionnaire.vue?vue&type=template&id=a4c249f2&scoped=true&"
import script from "./createQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./createQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./createQuestionnaire.vue?vue&type=style&index=0&id=a4c249f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c249f2",
  null
  
)

export default component.exports